import PersonalizationClient from "ms.personalization";

import { ARTICLE_TYPE, Story } from "~types/types";
import { getTransporterConfig } from "~utils/transporterConfig";

const PERSONALIZATION_CLIENT_URL = process.env.NEXT_PUBLIC_PERSONALIZATION_URL;
let _personalizationClient: ReturnType<typeof PersonalizationClient>;

export default function getPersonalizationClient() {
    if (typeof window === "undefined") {
        return null;
    }

    if (_personalizationClient === undefined) {
        _personalizationClient = new PersonalizationClient({
            url: PERSONALIZATION_CLIENT_URL,
        });
    }

    return _personalizationClient;
}

const DEFAULT_PERSONALIZATION_PARAMS = {
    includedSites: "bbiz;pursuits;technology;markets;bpol;bview;gadfly",
    thumbnailRequired: "false",
    decayCoefficient: 1,
    inactivePeriod: 2592000000,
    interactionsLimit: 1,
    maxAge: 7 * 24 * 3600 * 1000,
    limit: 1,
    rescorers: "random;tpx",
    "rescorers.tpx.minimumScore": 0.1,
    "rescorers.random.minimumScore": 0.1,
    excludedSites: "businessweek",
};

const ARTICLE_PERSONALIZATION_VARIANTS: Record<ARTICLE_TYPE, string> = {
    article: "Story",
    feature: "Feature",
    slideshow: "Slideshow",
    newsletter_campaign: "Story",
    letter: "Story",
    quicktake: "Story",
    breaking_news: "Story",
    explainers: "Feature",
};

export type PersonalizationStoryType = {
    assetID: string;
    assetType: string;
    duration: number;
    headline: string;
    publishedAt: string;
    sites: string[];
    thumbnailUrl: string;
    url: string;
};

export const getPersonalizationParams = (
    currentStory: Story,
    storyIds: string[],
    overrides = {}
) => {
    const type = (currentStory?.type || ARTICLE_TYPE.BASIC) as ARTICLE_TYPE;
    const variantName = ARTICLE_PERSONALIZATION_VARIANTS[type];

    // Article types passed through resourceTypes, backfillFacets, and currentResource
    const defaultResourceTypes = variantName;
    const defaultBackfillFacets = `${variantName}|All`;
    const currentResource = `${variantName}|${currentStory?.id}`;
    const exclude = storyIds.map((id) => `${variantName}|${id}`).join(";");

    const transporterConfig = currentStory
        ? getTransporterConfig(currentStory)
        : {};
    const personalizationParams = {
        ...DEFAULT_PERSONALIZATION_PARAMS,
        ...transporterConfig?.options,
        resourceTypes:
            transporterConfig?.options?.resourceTypes || defaultResourceTypes,
        backfillFacets:
            transporterConfig?.options?.backfillFacets || defaultBackfillFacets,
    };

    return {
        ...personalizationParams,
        currentResource,
        exclude,
        ...overrides,
    };
};
